import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../components/layout/AppLayout';
import { InfoRow } from '../components/servers/ServerWidgets';
import { BackLink, Section, VerdictBanner, cardStyle, formatWhen } from '../components/security/SecurityDetail';
import { apiGetRegistryVehicleUpdate } from '../api/client';

function valueText(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

export default function SecurityRegistryUpdateDetailPage() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError('');
      try {
        const result = await apiGetRegistryVehicleUpdate(id);
        if (!cancelled) setData(result);
      } catch (e) {
        if (!cancelled) setError(e.message || 'Failed to load update');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  return (
    <AppLayout>
      <div className="page-content">
        <BackLink />
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: '12px 0 4px' }}>Registry vehicle update</h1>
        <p style={{ color: '#64748b', marginTop: 0 }}>Tracking Cars · third-party request</p>
        {loading && <p style={{ color: '#64748b' }}>Loading…</p>}
        {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
        {!loading && data && (
          <div>
            <VerdictBanner
              level="info"
              text={`${data.vin} updated ${formatWhen(data.applied_at)}`}
            />
            <Section title="Vehicle">
              <div style={cardStyle}>
                <InfoRow label="VIN" value={data.vin} />
                <InfoRow label="Tracking" value={data.tracking_number || '—'} />
                <InfoRow label="Vehicle" value={[data.year, data.make, data.model].filter(Boolean).join(' ') || '—'} />
                <InfoRow label="Source" value={data.source_system || 'third party'} />
                <InfoRow label="Reference" value={data.external_reference || '—'} />
                <InfoRow label="Applied" value={formatWhen(data.applied_at)} />
              </div>
            </Section>
            <Section title="Changed fields">
              <div style={cardStyle}>
                {(data.changed_fields || []).length === 0 && <p style={{ margin: 0, color: '#64748b' }}>No field diffs recorded.</p>}
                {(data.changed_fields || []).map((field) => (
                  <div key={field.path} style={{ padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                    <strong style={{ fontSize: 13 }}>{field.path}</strong>
                    <p style={{ margin: '4px 0 0', fontSize: 13, color: '#94a3b8', textDecoration: 'line-through' }}>{valueText(field.old)}</p>
                    <p style={{ margin: '2px 0 0', fontSize: 14, color: '#065f46', fontWeight: 700 }}>{valueText(field.new)}</p>
                  </div>
                ))}
              </div>
            </Section>
            <Section title="Accidents added">
              <div style={cardStyle}>
                {(data.accidents_added || []).length === 0 && <p style={{ margin: 0, color: '#64748b' }}>No accidents added in this update.</p>}
                {(data.accidents_added || []).map((acc, index) => (
                  <div key={acc.id || index} style={{ padding: '10px 0', borderBottom: '1px solid #f1f5f9' }}>
                    <strong>{acc.date || '—'}</strong>
                    <p style={{ margin: '4px 0 0', color: '#475569' }}>{acc.description || '—'}</p>
                  </div>
                ))}
              </div>
            </Section>
          </div>
        )}
      </div>
    </AppLayout>
  );
}
